import React, { useState } from 'react';
import cx from 'classnames';

// Components
import DropdownSelect from '../../common/DropdownSelect/DropdownSelect';
import { CustomizeCardButton } from '../../ProductDetail/CustomizeCardButton';

// Utils
import { enrichQtyOptions } from '../../../pages/ProductDetail/utils';
import { priceFormatter } from '../../../../components/product/PricingUtils';

// Styles
import styles from './styles.module.less';

const QtyPriceSection = ({
  cost,
  defaultSelection,
  showDropdownOptionsOnTop,
  increment,
  max,
  min,
  onSelect,
  hideTitle,
  handleCustomizeClick,
  disableCustomizeButton,
}) => {
  const [currentValue, setCurrentValue] = useState(defaultSelection);

  function onMobileChange(event) {
    event.preventDefault();
    const newVal = parseInt(event.target.value, 10);
    setCurrentValue(newVal);
    onSelect(newVal);
  }

  function onDesktopChange(newVal) {
    setCurrentValue(newVal);
    onSelect(newVal);
  }

  return (
    <>
      <div
        className={cx(styles.title, {
          [styles.titleHide]: hideTitle,
        })}
      >
        Quantity
      </div>
      <div className={styles.productDetailPriceSection}>
        <div className={styles.qtySelect}>
          <DropdownSelect
            showOptionsOnTop={showDropdownOptionsOnTop}
            selected={currentValue}
            options={enrichQtyOptions(min, max, increment)}
            onSelect={onDesktopChange}
            matchButtonV2
          />
        </div>
        <div className={styles.mobileSelectContainer}>
          <select
            value={currentValue}
            onChange={onMobileChange}
            name="detailPrice"
            id="detail-price"
            className={styles.mobileSelect}
          >
            {enrichQtyOptions(min, max, increment).map(each => (
              <option key={each.label} value={each.value}>
                {each.label}
              </option>
            ))}
          </select>
        </div>
        <CustomizeCardButton
          handleCustomizeClick={handleCustomizeClick}
          disabled={disableCustomizeButton}
        />
        <div className={styles.priceTotal}>
          <span>{priceFormatter(cost.total)}</span>
        </div>
      </div>
    </>
  );
};

export default QtyPriceSection;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/DetailQtyPriced/DetailQtyPriced.jsx